/**
 * Returns the OS name
 * @return {String}
 */
export function getOS() {
  const subject = navigator.appVersion;
  let os;
  if (subject.indexOf('Win') !== -1) {
    os = 'windows';
  } else if (subject.indexOf('Mac') !== -1) {
    os = 'mac-osx';
  } else if (subject.indexOf('Linux') !== -1) {
    os = 'linux';
  } else if (subject.indexOf('X11') !== -1) {
    os = 'unix';
  } else {
    os = 'unknown';
  }
  return os;
}

/**
 * Returns browser info
 * @param  {String} userAgentString
 * @return {Object}
 */
export function getBrowser(userAgentString = navigator.userAgent) {
  // List of browsers which supports browser extensions
  const browsers = [
    ['edge', /Edge\/([0-9\\._]+)/],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\\.]+)(?:\s|$)/],
    ['opera', /Opera\/([0-9\\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\\.]+)(:?\s|$)$/],
    ['safari', /Version\/([0-9\\._]+).*Safari/],
  ];

  const browserInfo = browsers
    // eslint-disable-next-line array-callback-return, consistent-return
    .map(rule => {
      if (rule[1].test(userAgentString)) {
        const match = rule[1].exec(userAgentString);
        const version = match && match[1].split(/[._]/).slice(0, 3);
        if (version && version.length < 3) {
          Array.prototype.push.apply(version, version.length === 1 ? [0, 0] : [0]);
        }
        return {
          name: rule[0],
          version: version.join('.'),
          shortVersion: version[0],
        };
      }
    })
    .filter(Boolean)
    .shift();
  if (browserInfo) {
    return browserInfo;
  }
  return {
    name: 'unknown',
    version: '0',
    shortVersion: '0',
  };
}

/**
 * Returns a random string
 * @param  {Number} length
 * @return {String}
 */
export function getRandomString(length = 28) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
  let random = '';
  for (let i = 0; i < length; i++) {
    random += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return random;
}

/**
 * Returns pb_param item value
 * @param  {String} pb_param key
 * @return {String} pb_param value
 */
export function getInstallParam(key) {
  // localStorage not supported by jsdom and breaks builds
  if (typeof localStorage === 'undefined') return null;

  let pbParams = localStorage.getItem('pb_params');
  if (pbParams) {
    try {
      pbParams = JSON.parse(pbParams);
      if (pbParams && pbParams[key]) {
        return pbParams[key];
      }
    } catch (e) {}
  }
  return null;
}

export default {
  getOS,
  getBrowser,
  getRandomString,
  getInstallParam,
};



// WEBPACK FOOTER //
// ./src/modules/Helper.js